import { helper } from '@ember/component/helper';

/**
 * Template helper for adding two numbers.
 *
 * @param {number[]} params - The numbers to add
 * @returns {number} The sum of the two numbers
 *
 * @example
 * {{add 5 3}} → 8
 * {{add this.count 1}} → count + 1
 */
export function add([a, b]) {
  return Number(a) + Number(b);
}

export default helper(add);
